import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'src/app/services/oauth.service';

@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.css']
})
export class OauthCallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private oauth:OAuthService) { }

  ngOnInit(): void {
    const token = sessionStorage.getItem('access_token_oauth');
 
    if (token == null) {
      const cv =  sessionStorage.getItem('pkce_code_verifier');

      if(cv != null)
      {
       
        this.route.queryParams.subscribe(params => {
          const code = params['code'];
          const state = params['state'];

          if (code) {
            this.exchangeCodeForToken(code,state);
          }
        });
      }
    }
    else
    {
      this.route.queryParams.subscribe(params => {
        const state = params['state'];
        const stateParam = decodeURIComponent(state || '{}');
        const stateData = JSON.parse(stateParam);

        this.router.navigate(['/'],{queryParams:{lang:stateData.lang,ParamTax:stateData.ParamTax,token:stateData.token}});
      });
      
    }
    
  }

  async exchangeCodeForToken(code: string, state: string) {
    const codeVerifier = sessionStorage.getItem('pkce_code_verifier');

    // Wait for config to be loaded
    while (!this.oauth.clientId || !this.oauth.redirectUri || !this.oauth.authUrl) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    const formData = new FormData();
    formData.append('grant_type', 'authorization_code');
    formData.append('client_id', this.oauth.clientId);
    formData.append('code', code);
    formData.append('redirect_uri', this.oauth.redirectUri);
    formData.append('code_verifier', codeVerifier || '');

    const stateParam = decodeURIComponent(state || '{}');
    const stateData = JSON.parse(stateParam);

    // Build token endpoint from authUrl in config
    //const tokenUrl = this.oauth.authUrl.replace('/authorize', '/Token');
      const tokenUrl = this.oauth.tokenUrl;

    this.http
      .post(tokenUrl, formData)
      .subscribe((tokenResponse: any) => {
        // Save access token
        sessionStorage.setItem('access_token_oauth', tokenResponse.access_token);
        sessionStorage.setItem('refresh_token', tokenResponse.refresh_token);
        sessionStorage.removeItem('pkce_code_verifier');

        setTimeout(() => {
          this.router.navigate(['/'], { queryParams: { lang: stateData.lang, ParamTax: stateData.ParamTax, token: stateData.token } });
          setTimeout(() => {
            window.location.reload();
          }, 1100);
        }, 1000);
      });
  }

}
